import { SHW_ENV } from '@showell-labs/env';
import { toRemoteAssetHandlerUrl } from '@showell-labs/showell-commons/lib/utils/signedUrlUtils';

type PdfMeta = {
  numPages?: number;
  pages?: Record<number, unknown>;
};

const pdfMetaCache: Record<string, PdfMeta> = {};
const activeRequests: Record<string, Promise<PdfMeta>> = {};

function buildPdfMetaUrl(signedUrl: string) {
  const base64Url = btoa(signedUrl);
  const path = '/pdf-meta?url=:url&cacheBust=:cacheBust'
    .replace(':url', encodeURIComponent(base64Url))
    .replace(':cacheBust', Math.random().toString());

  return `${SHW_ENV.SHW_LAMBDA_HELPERS_URL}${path}`;
}

export async function getPdfMeta(
  fileId: string,
  signedUrl: string
): Promise<PdfMeta> {
  if (pdfMetaCache[fileId]) {
    return pdfMetaCache[fileId];
  }

  if (!activeRequests[fileId]) {
    activeRequests[fileId] = fetch(buildPdfMetaUrl(signedUrl)).then(
      async response => {
        if (!response.ok) {
          throw new Error('Failed to load PDF metadata');
        }

        const meta = (await response.json()) as PdfMeta;
        pdfMetaCache[fileId] = meta;
        delete activeRequests[fileId];
        return meta;
      },
      error => {
        delete activeRequests[fileId];
        throw error;
      }
    );
  }

  return activeRequests[fileId];
}

export function getPdfPageThumbnailUrl(
  signedUrl: string,
  page: number,
  width = 320,
  height = 180
) {
  return toRemoteAssetHandlerUrl(
    signedUrl,
    'resize',
    width,
    height,
    page,
    'jpg'
  );
}
